type WhopPixel = {
	q: unknown[][];
	t: number;
	s: string[];
	o: string;
	track: (...args: unknown[]) => void;
	setScope: (...scopes: unknown[]) => void;
	scope: (...scopes: unknown[]) => {
		track: (...args: unknown[]) => void;
	};
};

declare global {
	interface Window {
		whop?: WhopPixel;
	}
}

const WHOP_PIXEL_ORIGIN = "https://t.whop.tw";

function isLocalhost(hostname: string): boolean {
	return /^(localhost|127\.0\.0\.1|0\.0\.0\.0|\[::1\])$/.test(hostname);
}

/**
 * Install Whop's browser pixel and record the current page for one business.
 * The queue shape mirrors the installation snippet issued by Whop's dashboard.
 */
export function initWhopPixel(scope: string | undefined): void {
	if (
		!scope ||
		typeof window === "undefined" ||
		isLocalhost(window.location.hostname)
	)
		return;

	if (!window.whop) {
		const whop: WhopPixel = {
			q: [],
			t: Date.now(),
			s: [],
			o: WHOP_PIXEL_ORIGIN,
			track: (...args: unknown[]) => {
				whop.q.push([Date.now(), ...args]);
			},
			setScope: (...scopes: unknown[]) => {
				whop.s = scopes.filter(
					(value): value is string => typeof value === "string",
				);
				whop.q.push([Date.now(), "setScope", ...whop.s]);
			},
			scope: (...scopes: unknown[]) => ({
				track: (...args: unknown[]) => {
					whop.q.push([Date.now(), ...args, { __scope: scopes }]);
				},
			}),
		};
		window.whop = whop;

		const script = document.createElement("script");
		script.async = true;
		script.src = `${WHOP_PIXEL_ORIGIN}/s.js`;
		document.head.appendChild(script);
	}

	window.whop.setScope(scope);
	window.whop.track("page");
}
